import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"

// redirect away from legacy production domain to new one
if (window.location.hostname === "administration.intuidesk.com") {
  window.location.href =
    "https://admin.intuidesk.com" +
    window.location.pathname +
    window.location.search +
    window.location.hash
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
